// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__NotoSansJP_128efb', '__NotoSansJP_Fallback_128efb', system-ui, arial"},"className":"__className_128efb","variable":"__variable_128efb"};